import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { RoomAclEffects } from './room-acl.effects';
import { roomAclReducer } from './room-acl.reducer';

export const provideRoomAclStore = () => [provideState('roomAcls', roomAclReducer), provideEffects([RoomAclEffects])];
